import { Alert, Button } from 'antd'
import { useNavigate } from 'react-router-dom'
import { KnowledgeManage } from '../components/KnowledgeManage'
import { PageHeader, PageLoading } from '../components/ui'
import { KNOWLEDGE_SCOPE_META } from '../constants/knowledgeScope'
import { useAdminAuth } from '../lib/useAdminAuth'

const meta = KNOWLEDGE_SCOPE_META.enterprise

export default function EnterpriseKnowledge() {
  const navigate = useNavigate()
  const { ready, loggedIn } = useAdminAuth()

  if (!ready) return <PageLoading />

  if (!loggedIn) {
    return (
      <div className="public-page-panel">
        <PageHeader title={meta.title} description={meta.description} />
        <Alert
          type="info"
          showIcon
          message="请先登录"
          description="企业知识库维护需使用管理账号登录（默认 admin / admin123）。"
          action={
            <Button
              type="primary"
              onClick={() => void navigate('/manage/login?redirect=/enterprise')}
            >
              去登录
            </Button>
          }
        />
      </div>
    )
  }

  return (
    <div className="public-page-panel">
      <KnowledgeManage
        knowledgeScope="enterprise"
        title={meta.title}
        description={meta.description}
      />
    </div>
  )
}
